import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import SiteFilter from './SiteFilter'
import DateFilter from './DateFilter'

function FilterBar() {
  return (
    <Paper className="lbf-filter-bar">
      <Grid container spacing={1} justify="space-between">
        <Grid item lg={2} md={3} sm={4} xs={6}>
          <SiteFilter />
        </Grid>

        <Grid item lg={2} md={3} sm={4} xs={6}>
          <DateFilter />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default FilterBar
